"use client";

import { parseCustomLocation } from "@/app/[locale]/_lib/parseLocation";
import type { CustomLocation, MapAreaId } from "@/utils/location";
import { getNearestAreaId } from "@/utils/location";
import type { Coords } from "@/types/places";
import { useSearchParams } from "next/navigation";

export type SearchLocationOverride = {
  currentCustomLocation: CustomLocation;
  coords: Coords;
  currentArea: MapAreaId;
};

/**
 * The custom search location carried in `?lat&lon&locationName`, read in the
 * browser.
 *
 * The detail pages used to read these on the server and pass them into
 * `SiteHeader`. Their HTML is cached, so a server read comes back empty and a
 * shared deep link would lose the visitor's chosen location. Returns null when
 * the URL carries no location, or coordinates that do not validate.
 */
export function useSearchLocationFromUrl(): SearchLocationOverride | null {
  const searchParams = useSearchParams();

  const parsed = parseCustomLocation({
    lat: searchParams?.get("lat"),
    lon: searchParams?.get("lon"),
    locationName: searchParams?.get("locationName"),
  });

  if (!parsed) return null;

  return {
    currentCustomLocation: parsed,
    coords: { lat: parsed.lat, lon: parsed.lon },
    currentArea: getNearestAreaId(parsed.lat, parsed.lon),
  };
}
